import { environment } from '@environments/environment';

const env: any = environment;

export const PlUtil = {
  getUiFlags: (properties: any): any => {
    const obj: any = {};
    Object.keys(properties).forEach((prop: string) => {
      obj[prop] = PlUtil.getFlag(properties[prop]);
    });
    return obj;
  },
  getFlag: (flag: string) => {
    if (!PlUtil.isDebug()) return false;
    return localStorage.getItem(flag);
  },
  isDebug: () => localStorage.getItem('pl-debug'),
  debug(fn: Function) {
    if (!PlUtil.isDebug()) return;
    fn();
  },
  getEnvVar(envKey: string, localStorageKey?: string) {
    const val = localStorage.getItem(localStorageKey) || env[envKey];
    return val === 'undefined' ? null : val && val.length && val;
  },
};

export const isSet = (val: any) =>
  !(typeof val === 'undefined' || val === null);
